import { gql } from "apollo-boost"

export const createContracts = gql`
  mutation createContracts($data: CreateContractsInput!) {
    CreateContracts(data: $data)
  }
  `